/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/destructuring-assignment */
import React from 'react'
// import PropTypes from 'prop-types'
// import { useLocation } from 'react-router-dom'
import {
  Row,
  // Col,
  // InputGroup,
  // Form,
  // Button,
  // ButtonGroup,
} from 'react-bootstrap'
// import { Typeahead } from 'react-bootstrap-typeahead'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faRotateLeft, faRotateRight } from '@fortawesome/free-solid-svg-icons'
// import { SocketContext, Context } from './ContextProvider'

function TopBar() {
  // const { sendMessage } = useContext(SocketContext)
  // const { containerId } = useContext(Context)

  return <Row className="w-100 h-100 d-flex flex-nowrap py-2" />
}

export default TopBar
